import React from 'react'
import { Box, Typography } from '@mui/material'
import { DeleteOutlined, DragIndicatorOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { CanvasItemCard, DeleteButton, DragHandle, CanvasItemIcon } from './DesignerCanvasSection.styles'

export interface ICanvasDefaultItemProps {
  item: any
  componentIcon: React.ReactNode
  isSelected: boolean
  accentColor: string
  isDragging: boolean
  isDragOver: boolean
  onSelectItem: (id: string) => void
  onDeleteItem: (id: string) => void
  onDragStart: (e: React.DragEvent) => void
  onDragOver: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  onDragEnd: () => void
}

export const CanvasDefaultItem: React.FC<ICanvasDefaultItemProps> = ({
  item,
  componentIcon,
  isSelected,
  accentColor,
  isDragging,
  isDragOver,
  onSelectItem,
  onDeleteItem,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}) => {
  const { t: translate } = useTranslation(['dynamic-report'])

  return (
    <CanvasItemCard
      key={(item as any).id}
      isSelected={isSelected}
      accentColor={accentColor}
      isDragging={isDragging}
      isDragOver={isDragOver}
      onClick={() => onSelectItem((item as any).id)}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <DragHandle>
        <DragIndicatorOutlined fontSize="small" />
      </DragHandle>
      <CanvasItemIcon accentColor={accentColor}>{componentIcon}</CanvasItemIcon>
      <Box>
        <Typography variant="body2" fontWeight={600} fontSize="0.8rem">
          {(item as any).label}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {translate(`block-${((item as any).type as string).toLowerCase()}`, {
            ns: 'dynamic-report',
          })}
        </Typography>
      </Box>
      <DeleteButton
        size="small"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          onDeleteItem((item as any).id)
        }}
        title={translate('delete-item', { ns: 'dynamic-report' })}
      >
        <DeleteOutlined fontSize="small" />
      </DeleteButton>
    </CanvasItemCard>
  )
}
